import { spacing } from './space'

export const sizes = {
  ...spacing
}
